/**
 * SYNCED ENUM: Values in frontend and backend versions of ScreeningModality must be synced!
 *
 * Any changes here should reflect valid options in the backend enum at:
 * monoweb.django_apps.preventive_care.protocols.types.ScreeningModality
 */
export enum ScreeningModality {
  BREAST_MRI = 'breast_mri',
  CARDIO_PANEL = 'cardio_panel',
  CLINICAL_BREAST_EXAM = 'clinical_breast_exam',
  COLOGUARD = 'cologuard',
  COLONOSCOPY = 'colonoscopy',
  GENETICS_TESTING = 'genetics_testing',
  FIT_TEST = 'fit_test',
  HPV_TEST = 'hpv_test',
  LUNG_CT = 'lung_ct',
  MAMMOGRAM = 'mammogram',
  PAP_SMEAR = 'pap_smear',
  PARTIAL_COLONOSCOPY = 'partial_colonoscopy',
  PSA_TEST = 'psa_test',
  SKIN_DERM_EXAM = 'skin_derm_exam',
  VIRTUAL_COLONOSCOPY = 'virtual_colonoscopy',
}
